import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'race_ethnic_group_skin_color_2'

export const dataPointDefinition = {
  retracedId: 'race_ethnic_group_skin_color_2',
  name: 'Race / Ethnic Group / Skin Color',
  description:
    'Race is the ethnic group to which an individual belongs by reason of heredity, and includes any linguistic communities or minority groups whose identity is based on religious or cultural characteristics, or on national or ethnic origin. Difference of color is the most apparent, though not the sole, ',
  meta: {
    slcpMeta: {
      key: 'disc-7--1',
      number: 'WT-DIS-10-1',
      dataType: 'boolean',
      masterType: 'Question',
      multiSelectKey: 'disc-7',
      optionList: 'ms',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[1],wt-dis-24,Yes',
      machineShowHide: '[1],wt-dis-24,1',
      completionCondition: 'any ms',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'ms',
      name: 'ms',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'disc-7--1', version: '1.7.0', provider: 'slcp'}],
  sortingId: 26740,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
